var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmbotLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.99 19.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fmbt-horiz-cls-1{fill:#58595b;}.fmbt-horiz-cls-2{fill:#317fbf;}.fmbt-horiz-cls-3{fill:#307fbe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-1",
    d: "M29.69,6.91h-5.5V9H29v2.6h-4.8v4.3h-3.3V4.11h8.9v2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-1",
    d: "M47.89,15.81h-3.6l-.7-1.8h-4.9l-.7,1.8h-3.6l4.9-11.7H43Zm-8.2-4.4h2.9l-1.5-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-1",
    d: "M63.09,7.81a3.58,3.58,0,0,1-2.4,3.4l2.8,4.6h-3.7l-2.4-4.2h-.9v4.2h-3.3V4.11h5.6C61.09,4.11,63.09,5.41,63.09,7.81Zm-6.7-1.2v2.6h1.8a1.31,1.31,0,1,0,0-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-1",
    d: "M85,15.81h-3.4l-.5-7.1-2.4,7.1h-3.5l-2.4-7.1-.5,7.1h-3.4L70,4.11h4.5l2.6,7.5,2.6-7.5H84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-2",
    d: "M100.59,7.21A2.74,2.74,0,0,1,99,9.71a2.91,2.91,0,0,1,2,2.8c0,1.9-1.7,3.3-4.1,3.3h-6V4.11h5.8C99,4.11,100.59,5.41,100.59,7.21Zm-6.4-.6v2.2H96c.9,0,1.3-.5,1.3-1.1s-.5-1.1-1.3-1.1Zm0,4.3v2.3h2c.9,0,1.4-.5,1.4-1.2s-.5-1.1-1.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-2",
    d: "M119.19,9.91a6.4,6.4,0,1,1-6.4-6.2A6.21,6.21,0,0,1,119.19,9.91Zm-9.5,0a3.06,3.06,0,0,0,3,3.2,3,3,0,0,0,3-3.2,3,3,0,1,0-6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-2",
    d: "M134,6.91h-3.5v8.9h-3.3V6.91h-3.5V4.11H134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-3",
    d: "M14.5,11.47A19.17,19.17,0,0,0,12,6.2.41.41,0,0,0,11.63,6a.39.39,0,0,0-.36.19h0A28.08,28.08,0,0,0,9.35,9.76a7.12,7.12,0,0,0-.73,2.86A7.47,7.47,0,0,0,10.94,18a7.29,7.29,0,0,1-1.5.76c-2.71-1-4.91-4.05-4.19-7S8,6,9.8,3.49l0,0a.35.35,0,0,0,.08-.22v0A.37.37,0,0,0,9.83,3l0,0h0C9.09,2,8.37,1.05,7.61.12A.42.42,0,0,0,7,.12,50.71,50.71,0,0,0,1.75,7.69C.58,9.78-.45,12,.2,14.45a7.42,7.42,0,0,0,6.33,5.46,7.38,7.38,0,0,0,7.4-4.13A6.64,6.64,0,0,0,14.5,11.47ZM4.25,18.35a6.31,6.31,0,0,1-3.14-7.29A27,27,0,0,1,4.88,4.34c.78-1.11,1.58-2.2,2.43-3.25.57.7,1.11,1.42,1.64,2.15A43.82,43.82,0,0,0,6,7.86,11.83,11.83,0,0,0,4.32,12.2a7.25,7.25,0,0,0,3.82,6.85A6.14,6.14,0,0,1,4.25,18.35ZM12.86,16a6.94,6.94,0,0,1-1.24,1.45,6.4,6.4,0,0,1-2.16-5,12.32,12.32,0,0,1,2.17-5.25,15,15,0,0,1,2.06,4.48A6,6,0,0,1,12.86,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-3",
    d: "M9.91,3.23a.3.3,0,0,1-.11.26l0,0A.35.35,0,0,0,9.91,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-horiz-cls-3",
    d: "M9.91,3.19A.37.37,0,0,0,9.83,3l0,0A.36.36,0,0,1,9.91,3.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmbotLogoHorizontal);
export default __webpack_public_path__ + "static/media/farmbot-logo-horizontal.eed5b9f9fc0ea68a46415598abb1308f.svg";
export { ForwardRef as ReactComponent };